import { RasterComponentOption } from "../components/raster_component"
import { VectorLayerData } from "../components/vector_component"

const yearRange = [2001, 2025]
const years = Array.from({ length: yearRange[1] - yearRange[0] + 1 }, (_, i) => yearRange[0] + i)

const disasters = ['fire', 'flood', 'landslide']

const options: RasterComponentOption[] = []

disasters.forEach(disaster => {
    years.forEach(year => {
        return options.push({ name: `${year} number of ${disaster}s`, source: `ind:${disaster}_${year}`, non_values: [0], option: [disaster, year.toString()] })
    })
})

export const IndDisasterProperties: RasterComponentOption[] = options

const disastersDistrictKey = [{key: 'ffire', name: 'Forest fires'}, {key: 'flood', name: 'Floods'}, {key: 'lslide', name: 'Landslides'}]
const yearsDistrict = [2019, 2020, 2021, 2022, 2023, 2024, 2025]


export const IndDisasterDistrictProperties: VectorLayerData[] = [
]

disastersDistrictKey.forEach(disaster => {
    yearsDistrict.forEach(year => {
        return IndDisasterDistrictProperties.push({
            name: `${disaster.name} ${year}`,
            source: ['ind:merged_all_transformed'],
            key: `${disaster.key}${year}`,
            output: 'NumericTileGrid',
            distributed: false,
            wms: false,
            groups: [disaster.name, year.toString()],
            valueAsNaN: [0], // 0s will be considered NaN
        })
    })
})